import { Component, OnInit, Input, } from '@angular/core';

@Component({
  selector: 'app-booking-details-customs-display',
  templateUrl: './booking-details-customs-display.component.html',
  styleUrls: ['./booking-details-customs-display.component.scss']
})
export class BookingDetailsCustomsDisplayComponent implements OnInit {

  @Input()
  appCopy;

  @Input()
  selectedLanguage;
  
  @Input() excessCustomsPayment;

  @Input()
  receiptImg;

  @Input() currencySymbol;
  constructor() { }

  ngOnInit() {
  }

}
